import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from "@sentry/angular";
import { EnvironmentNames } from "blu-utilities";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

const isProduction =
  environment.environmentName === EnvironmentNames.PRODUCTION;

if (environment.environmentName !== EnvironmentNames.LOCAL) {
  init({
    dsn: "https://a2c053448846c687f90e44d1cd7e94c0@sentry.bluuniverse.com/20",
    release: environment.sentryRelease,
    environment: isProduction ? "production" : "development",
    integrations: [browserTracingIntegration(), replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

if (isProduction) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
